import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';
import SharedHeadColumns from '../SharedHeadColumns';

const Head: React.FC = () => (
  <thead className="bg-gray-50">
    <tr>
      <SharedHeadColumns />
      <th className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900 lg:table-cell">
        <T kind="Status" />
      </th>
      <th className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900 lg:table-cell">
        <T kind="Reason" />
      </th>
    </tr>
  </thead>
);

export default observer(Head);
